<script setup>
/* eslint-disable */
import { ref, onMounted, computed } from "vue";
import { useLaternaStore } from '@/stores/laterna';
import _ from 'lodash';
import { useRouter } from "vue-router";
import { useDragScroll } from '@/composables/useDragScroll'
const laternaStore = useLaternaStore();
const router = useRouter();
const props = defineProps({
	section: {
		type: Object,
		required: true,
	},
})

const items = ref([]);
const slider = ref(null)

useDragScroll(slider, {
    speed: 1.5
})

onMounted(async () => {
    items.value = await useLaternaStore().fetchLandingSectionItems(props.section.id)
})

const goToPage = (item) => {
    if (item.new_tab) openInNewTab(item.url)
    else navigateToUrl(item.url);
}

const openInNewTab = (url) => {
    if (url.startsWith('http')) {
        window.open(url, '_blank');
        return;
    }

    window.open(process.env.VITE_APP_SITE_URL + url);
}

const navigateToUrl = (url) => {
    if (url.startsWith(import.meta.env.VITE_APP_SITE_URL)) {
		const sliced = url.slice(import.meta.env.VITE_APP_SITE_URL.length);

		router.push({'path': sliced});
		return;
	}

    if (url.startsWith('http')) {
        window.location.href = url;
        return;
    }

    router.push({'path': url});
};


const sortedItems = computed(() => {
	return _.orderBy(items.value, 'sort', 'asc');
});

</script>
<template>
<div class="container-sm">
    <div ref="slider" class="casino-categories" draggable="false">
        <div v-for="item in sortedItems" :key="item.id" @click="goToPage(item)" class="category-card bonus">
            <img :src="item.media?.path" />
        </div>
    </div>
</div>
</template>
<style scoped>
.casino-categories {
    display: flex;
    gap: 7px;
    overflow-x: auto;
    padding: 20px 0px 20px 0px;
}

.casino-categories::-webkit-scrollbar {
    height: 6px;
}

.casino-categories::-webkit-scrollbar-thumb {
    background: #2c3a48;
    border-radius: 4px;
}

.category-card {
    /* user-select: none;
    -webkit-user-drag: none; */
    width: 180px;
    height: 245px;
    border-radius: 18px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: transform 0.25s
    ease, box-shadow 0.25s
    ease;
}

.category-card img {
    width: 180px;
    height: 245px;
    border-radius: 18px;;
    object-fit: fill;
    /* pointer-events: none; */
}

.category-card:hover {
    transform: translateY(-6px);
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.45);
}

/* 🎨 Gradients */



@media screen and (min-width: 300px) and (max-width: 767px) {
    .category-card {
        width: 120px;
        height: 160px;
        border-radius: 18px;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: transform 0.25s
        ease, box-shadow 0.25s
        ease;
    }

    .category-card img {
        width: 120px;
        height: 160px;
        border-radius: 18px;;
        object-fit: fill;
    }

}

</style>